import { render, staticRenderFns } from "./OrderExtraData.vue?vue&type=template&id=7e803ecf&scoped=true&"
import script from "./OrderExtraData.vue?vue&type=script&lang=js&"
export * from "./OrderExtraData.vue?vue&type=script&lang=js&"
import style0 from "./OrderExtraData.vue?vue&type=style&index=0&id=7e803ecf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e803ecf",
  null
  
)

export default component.exports